var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        staticClass: "popup",
        attrs: { id: "popup_thank_choosing_new" },
        on: {
          click: function($event) {
            return _vm.$store.commit("openShareModal", false)
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "popup_block",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("div", {
              staticClass: "close",
              on: {
                click: function($event) {
                  return _vm.$store.commit("openShareModal", false)
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "title_popup" }, [
              _vm._v("\n                Share for download\n            ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pos_relative share-buttons" }, [
              _c("ul", [
                _c(
                  "li",
                  [
                    _c("fb-share", {
                      model: {
                        value: _vm.is_success,
                        callback: function($$v) {
                          _vm.is_success = $$v
                        },
                        expression: "is_success"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65e55e6c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65e55e6c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/open-share-modal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-65e55e6c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/open-share-modal.vue
// module chunks = 0